export default __webpack_public_path__ + "static/media/Rectangle 26.36f56e92.png";